import { DatePipe } from '@angular/common';
import { datesEqual } from '@shared/utils/helpers.util';
import { DoubleNumberInputTableFilter, RangeTableFilter, TableChip, TableFilter } from '@shared/components/table-filter-menu/table-filter-menu.models';
import { RadioFilterItem } from './components/radio-filter/radio-filter.models';

export const getChipData = (
  groupName: string,
  tableFilterConfig: TableFilter,
  value: string | null,
): TableChip[] => {
  const initialValue = tableFilterConfig.initialValue;

  if (value !== initialValue && value !== undefined && value !== null) {
    return [{ groupName, tableFilterConfig, value }];
  } else {
    return [];
  }
};

export const getRangeChipData = (
  groupName: string,
  tableFilterConfig: DoubleNumberInputTableFilter,
  value: Record<string, string | null>,
): TableChip[] => {
  const from = value?.[tableFilterConfig.fromFilter.controlName];
  const to = value?.[tableFilterConfig.toFilter.controlName];

  const fromValue = from !== tableFilterConfig.fromFilter.initialValue && from;
  const toValue = to !== tableFilterConfig.toFilter.initialValue && to;

  if (!fromValue && !toValue) {
    return [];
  }

  return [{ groupName, tableFilterConfig, value }];
};

export const getRangeChipContent = (
  value: Record<string, string | null>,
  tableFilterConfig: RangeTableFilter,
  label: string,
  unit: string = '',
  fromLabel = 'від',
  toLabel = 'до'): string => {
  const from = value?.[tableFilterConfig.fromFilter.controlName];
  const to = value?.[tableFilterConfig.toFilter.controlName];

  const fromValue = from !== tableFilterConfig.fromFilter.initialValue && from;
  const toValue = to !== tableFilterConfig.toFilter.initialValue && to;

  if (!fromValue && !toValue) {
    return '';
  }
  if (fromValue && !toValue) {
    return `${label} ${fromLabel} ${fromValue} ${unit}`;
  }
  if (!fromValue && toValue) {
    return `${label} ${toLabel} ${toValue} ${unit}`;
  }

  return `${label} ${fromValue} ${fromValue === toValue ? '' : '- ' + toValue} ${unit}`;
};

export function getDateRangeChipContent(
  value: Record<string, string | null>,
  tableFilterConfig: RangeTableFilter,
  dateLabel: string,
  fromLabel = 'з',
  toLabel = 'по',
): string {
  const dateFrom = value?.[tableFilterConfig.fromFilter.controlName];
  const dateTo = value?.[tableFilterConfig.toFilter.controlName];

  const fromDateValue = dateFrom !== tableFilterConfig.fromFilter.initialValue && dateFrom;
  const toDateValue = dateTo !== tableFilterConfig.toFilter.initialValue && dateTo;

  if (!fromDateValue && !toDateValue) {
    return '';
  }

  const pipe = new DatePipe('en-US');

  if (fromDateValue && !toDateValue) {
    return `${dateLabel} ${fromLabel} ${pipe.transform(dateFrom, 'dd.MM.yyy')}`;
  }
  if (!fromDateValue && toDateValue) {
    return `${dateLabel} ${toLabel} ${pipe.transform(dateTo, 'dd.MM.yyy')}`;
  }

  return `${dateLabel} ${pipe.transform(dateFrom, 'dd.MM.yyy')}${
    datesEqual(dateFrom, dateTo) ? '' : ' - ' + pipe.transform(dateTo, 'dd.MM.yyy')
  }`;
}

export function findOptionLabel(options: RadioFilterItem[], value: string | boolean): string {
  return options.find(option => option.value === value)?.label;
}
